module.exports = __webpack_public_path__ + "static/media/shenzi.9463895c.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/maiz/climasense/elotero/curativa/shenzi.png
// module id = 1714
// module chunks = 3